import React from 'react';
import * as css from './version.module.scss';
import classnames from 'classnames';

interface Props {
  onlyEnv?: boolean;
  className?: string;
  envClassName?: string;
  versionClassName?: string;
}

const Version: React.FC<React.PropsWithChildren<Props>> = ({
  onlyEnv,
  className,
  envClassName,
  versionClassName,
}) => {
  const version =
    process.env.REACT_APP_VERSION !== undefined
      ? process.env.REACT_APP_VERSION
      : '';

  const environment = process.env.REACT_APP_BUILD_ENV
    ? process.env.REACT_APP_BUILD_ENV !== 'prod'
      ? process.env.REACT_APP_BUILD_ENV
      : undefined
    : process.env.REACT_APP_ALP_ENV;

  if (!environment || ['prod', 'production'].includes(environment))
    // Ensure that environment is not shown in production
    return onlyEnv ? (
      <></>
    ) : (
      <div className={classnames(css.version, className ? className : '')}>
        <span className={versionClassName}>{version}</span>
      </div>
    );

  return (
    <div className={classnames(css.version, className ? className : '')}>
      {onlyEnv ? (
        <span className={envClassName}>{environment}</span>
      ) : (
        <>
          <span className={envClassName}>{`${environment}:`}</span>{' '}
          <span className={versionClassName}>{version}</span>
        </>
      )}
    </div>
  );
};

export default Version;
